import { jsx as l } from "react/jsx-runtime";
import * as n from "react";
import u from "react";
import { P as b } from "./chunks/index.CiR8ycRn.js";
import { c as N } from "./chunks/index.rKuIKazb.js";
import { Text as R } from "./text.js";
import './assets/label.css';var _ = "Label", s = n.forwardRef((e, r) => /* @__PURE__ */ l(
  b.label,
  {
    ...e,
    ref: r,
    onMouseDown: (a) => {
      var t;
      a.target.closest("button, input, select, textarea") || ((t = e.onMouseDown) == null || t.call(e, a), !a.defaultPrevented && a.detail > 1 && a.preventDefault());
    }
  }
));
s.displayName = _;
var w = s;
const x = "_label_18u2d_2", L = {
  label: x
}, g = u.forwardRef(
  ({
    children: e,
    htmlFor: r,
    onClick: a,
    disabled: o,
    color: t,
    variant: c = "cap-100",
    className: i,
    ...m
  }, f) => {
    const d = N(L.label, i);
    return /* @__PURE__ */ l(
      R,
      {
        ...m,
        variant: c,
        color: o ? "c-disabled" : t,
        className: d,
        asChild: !0,
        children: /* @__PURE__ */ l(w, { ref: f, htmlFor: r, onClick: a, children: e })
      }
    );
  }
);
g.displayName = "Label";
export {
  g as Label
};
//# sourceMappingURL=label.js.map
